import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import { Modal, Button } from "react-bootstrap";
import axios from 'axios';
import apiUrl from '../../../apiUrlConstant';
import styled from 'styled-components';
import datatableOptions from '../../../layout/datatableConstants';
import moment from 'moment';
import { debounce } from 'lodash';
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { faChevronRight, faCogs, faPen, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddSubStage from './Add';
import { getUserCategory, numberFormat } from "../../../utils/index";

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #003970;
`;

class TaskList extends Component {
    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
        });

        this.state = {
            subStageLists: [],
            totalRows: 10,
            loading: false,
            filterText: '',
            statusFilter: '', // Added for status filter
            perPage: 10,
            page: 1,
            editModalFlag: false,
            actieveId: null,
            activeTaskData: {},
            editType: '',
            addSection: '',
            showModal: false,
            modalForm: ''
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.fetchTasks = this.fetchTasks.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.openModal = this.openModal.bind(this);
        this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this); // Added for status filter
        this.closeTaskModel = this.closeTaskModel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount() {
        this.fetchTasks();

        // try {
        //     const response = axios.get(
        //       `${apiUrl.apiUrl.url}/leads/getDropReasons`
        //     );
        //     //setData(response.data.data);
        //     //setTotalRows(response.data.total);
        //   } catch (error) {
        //     console.error("Error fetching data: ", error);
        //   }
    }

    handlePageChange(page) {
        this.fetchTasks(this.state.filterText, this.state.statusFilter, page);
    }

    closeTaskModel() {
        this.setState({ showModal: false });
        this.fetchTasks();
    }

    handlePerRowsChange(newPerPage, page) {
        this.setState({ perPage: newPerPage });
        this.fetchTasks(this.state.filterText, this.state.statusFilter, page);
    }

    clearFilter() {
        this.setState({ filterText: '', statusFilter: '' }, () => {
            this.fetchTasks();
        });
    }

    handleFilter(event) {
        const filterValue = event.target.value;
        this.setState({ filterText: filterValue }, () => {
            debounce(() => {
                this.fetchTasks(this.state.filterText, this.state.statusFilter, this.state.page);
            }, 300)();
        });
    }

    handleStatusFilterChange(event) {
        const statusValue = event.value;
        this.setState({ statusFilter: statusValue }, () => {
            this.fetchTasks(this.state.filterText, this.state.statusFilter, this.state.page);
        });
    }

    openModal() {
        this.setState({ showModal: true });
    }

    handleDelete(id){
        if (window.confirm("Are you sure you want to delete this item?")) {
            this.setState({ loading: true });
            axios.get(`${apiUrl.apiUrl.url}/leads/drop-reason-delete`, {
                params: {
                    id: id
                },
            })
            .then((response) => {
                if (response.data.status === 'success') {
                   this.fetchTasks();
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
        }
    }

    fetchTasks(filterText = '', statusFilter = '', page = 1) {
        this.setState({ loading: true });

        axios
            .get(`${apiUrl.apiUrl.url}/leads/drop-reason-list`, {
                params: {
                    per_page: this.state.perPage,
                    page: page,
                    filter: filterText,
                    status: statusFilter, // Pass the status filter value to the API
                },
            })
            .then((response) => {
                if (response.data.status === 'success') {
                    this.setState({
                        subStageLists: response.data.data,
                        totalRows: response.data.total,
                        loading: false,
                        page: page,
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    render() {

        const columns = [
            {
                name: 'Sr No',
                selector: 'id',
                sortable: true,
                cell: (record, index) => (
                    (this.state.page - 1) * this.state.perPage + index + 1
                )
            },
            {
                name: 'Title',
                selector: 'title',
                sortable: true,
                cell: (record) => (
                    record.title.charAt(0).toUpperCase() + record.title.slice(1)
                ),
            },

            {
                name: 'Added On',
                selector: 'created_on',
                sortable: true,
                cell: (record) => moment(record.created_on).format('DD-MMM-YYYY'),
            },
            {
                name: 'Action',
                cell: (record) => (
                    record.status !== 'completed' && (
                        <div className='d-flex align-items-center gap-2'>
                            <button
                                title='Delete Reason'
                                className='bg-white'
                                onClick={() => {
                                    this.handleDelete(record.id);
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} color='orange' />
                            </button>
                        </div>
                    )
                )
            },
        ];

        return (
            <>
                <div className="parentContainer">
                    <div className="absoluteItemForTopBar">
                        <div className="new_breadcrumbs_design">
                            <ul className="d-flex align-items-center gap-3 p-0 m-0">
                                <li>
                                    <Link to="/leads" style={{ color: "#000", textDecoration: "none" }}>Lead</Link>
                                </li>
                                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                                <li>
                                    <Link to="#">Master</Link>
                                </li>
                                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                                <li>
                                    <Link to="#">Drop Reason</Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="masterContainer tableFirstElementPadding p-0">
                        <div className='unitFormContainerNew '>
                            <div className="row m-0">
                                <div className="col-8 ps-0">
                                </div>
                                <div className="col-4 d-flex justify-content-end pe-0 align-items-center">
                                    <button className="create_lease_landlord" onClick={() => { this.setState({ showModal: true, modalForm: 'add' }) }} >Add Reason</button>
                                </div>
                            </div>
                        </div>

                        <div className="tableContainer">
                            <DataTable
                                title=""
                                columns={columns}
                                data={this.state.subStageLists}
                                customStyles={datatableOptions.datatableOptions.customStyle}
                                progressPending={this.state.loading}
                                pagination
                                paginationServer
                                paginationTotalRows={this.state.totalRows}
                                onChangeRowsPerPage={this.handlePerRowsChange}
                                onChangePage={this.handlePageChange}
                                paginationComponentOptions={datatableOptions.datatableOptions.paginationOptions}
                            />
                        </div>

                        <Modal show={this.state.showModal} className='customModalFroTaskAndComment' onHide={() => this.setState({ showModal: false })} backdrop="static">
                            <Modal.Header closeButton>
                                <Modal.Title>{this.state.modalForm === "add" ? "Add Reason" : "Edit sub stage"} </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {this.state.modalForm === 'add' ? (
                                    <AddSubStage closeModal={this.closeTaskModel} />
                                ) : (
                                    <></>
                                    // <EditSubStage closeModal={this.closeTaskModel} id={this.state.actieveId} />
                                )
                                }
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </>
        );
    }
}

export default TaskList;
